'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _forms = require('utils/forms');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var homePhoneRenderProps = (0, _forms.objInArrayFieldProps)({
    findProp: 'type',
    findValue: 'Home',
    valueProp: 'number',
    WrappedComponent: _components2.Input
});

var EmergencyContactInformation = function EmergencyContactInformation(_ref) {
    var intl = _ref.intl,
        initialValues = _ref.initialValues,
        hiddenValues = _ref.hiddenValues,
        requirementsByCode = _ref.requirementsByCode,
        bookingId = _ref.bookingId,
        isFetchingRequirementData = _ref.isFetchingRequirementData,
        handleSubmit = _ref.handleSubmit,
        error = _ref.error,
        invalid = _ref.invalid,
        pristine = _ref.pristine,
        submitSucceeded = _ref.submitSucceeded,
        submitFailed = _ref.submitFailed,
        submitting = _ref.submitting;


    var emergencyContactReq = requirementsByCode.EMERGENCY_CONTACT_DETAILS;
    var customerHref = emergencyContactReq.fieldResourceHrefsByType.customers;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components2.FormErrorMessage, { errorCode: error, invalid: invalid, submitFailed: submitFailed, submitting: submitting }),
        _react2.default.createElement(
            'form',
            null,
            _react2.default.createElement(_components2.FieldSet, {
                requirement: emergencyContactReq,
                fields: [{
                    id: 'firstName',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formEmergencyContactInformation.firstName',
                        defaultMessage: 'First Name' }),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'firstName',
                        name: '[\'' + customerHref + '\'].emergency_contacts[0].first_name',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: emergencyContactReq })
                }, {
                    id: 'lastName',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formEmergencyContactInformation.lastName',
                        defaultMessage: 'Last Name' }),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'lastName',
                        name: '[\'' + customerHref + '\'].emergency_contacts[0].last_name',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: emergencyContactReq })
                }, {
                    id: 'phoneNumber',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formEmergencyContactInformation.phoneNumber',
                        defaultMessage: 'Phone Number' }),
                    field: _react2.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                        id: 'phoneNumbers',
                        name: '[\'' + customerHref + '\'].emergency_contacts[0].phone_numbers',
                        hiddenValues: hiddenValues,
                        type: 'tel',
                        requirement: emergencyContactReq,
                        parse: _forms.parsePhone
                    }, homePhoneRenderProps))
                }] }),
            _react2.default.createElement(_components2.FormSubmit, {
                handleSubmit: handleSubmit,
                invalid: invalid,
                pristine: pristine,
                submitting: submitting,
                submitSucceeded: submitSucceeded,
                isFetchingRequirementData: isFetchingRequirementData })
        )
    );
};
EmergencyContactInformation.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    initialValues: _propTypes2.default.object.isRequired,
    hiddenValues: _propTypes2.default.object.isRequired,
    requirementsByCode: _propTypes2.default.object.isRequired,
    bookingId: _propTypes2.default.string.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.string,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    submitSucceeded: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reduxForm.reduxForm)({
    form: 'EmergencyContactInformation',
    enableReinitialize: true
})(EmergencyContactInformation));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/EmergencyContactInformation.js
// module id = 1320
// module chunks = 0